module.exports = __webpack_public_path__ + "static/media/pencil.9e9e6129.svg";